// extracted by mini-css-extract-plugin
module.exports = {"menu":"src-routers-menu-module__menu--30YrN"};